/*
  Gratis-Produkt ab Warenwert (Theme-Einstellungen > Aktionen).
  - Legt das Gratis-Produkt als eigene Zeile mit Property _lieberge_gift in den Warenkorb,
    sobald der Warenwert (ohne Gratis-Zeile, ohne Gutscheine, nach Rabatten) die Schwelle erreicht.
  - Nimmt es wieder heraus, wenn der Warenwert darunter fällt oder die Aktion aus ist.
  - Kauft der Kunde dasselbe Produkt regulär, bleibt das eine eigene, bezahlte Zeile.
  - Entfernt der Kunde das Geschenk selbst, wird es für diesen Warenkorb nicht erneut hinzugefügt.
  Den Preis setzt der automatische Rabatt im Shopify-Admin auf 0 €.
*/
(() => {
  const cfg = window.liebergeGift;
  if (!cfg) return;

  const PROP = '_lieberge_gift';
  const ATTR = '_lieberge_gift_declined';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  const cartWrite = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  let lastCart = null;
  let declinedPending = false;
  let busy = false;
  let queued = false;
  let timer = null;

  const isGift = (item) => item.properties && item.properties[PROP];

  const post = (path, body) =>
    nativeFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then((r) => r.json());

  // Merkt sich, wenn der Kunde die Geschenk-Zeile selbst auf 0 setzt.
  function checkManualRemoval(url, init) {
    if (!lastCart || !/\/cart\/change/.test(url) || !init || typeof init.body !== 'string') return;
    let body;
    try { body = JSON.parse(init.body); } catch (e) { return; }
    if (Number(body.quantity) !== 0) return;
    const item = body.line
      ? lastCart.items[Number(body.line) - 1]
      : lastCart.items.find((i) => i.key === body.id);
    if (item && isGift(item)) declinedPending = true;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 150);
  }

  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    checkManualRemoval(url, init);
    const result = nativeFetch(input, init);
    // Erst nach der kompletten Antwort abgleichen, sonst überschreibt das Theme die Anzeige danach mit dem alten Stand
    if (cartWrite.test(url)) result.then((r) => r.clone().text()).then(schedule, schedule);
    return result;
  };

  // Apps, die noch XMLHttpRequest nutzen
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (cartWrite.test(String(url))) this.addEventListener('load', schedule);
    return xhrOpen.apply(this, arguments);
  };

  async function sync() {
    if (busy) { queued = true; return; }
    busy = true;
    try {
      const cart = await nativeFetch(root + 'cart.js').then((r) => r.json());
      lastCart = cart;

      const base = cart.items
        .filter((i) => !isGift(i) && !i.gift_card)
        .reduce((sum, i) => sum + i.final_line_price, 0);
      const variant = cfg.variantId;
      const qualifies = cfg.enabled && variant && base >= cfg.threshold;

      if (declinedPending) {
        declinedPending = false;
        if (qualifies) await post('cart/update.js', { attributes: { [ATTR]: String(variant) } });
        cart.attributes = Object.assign({}, cart.attributes, { [ATTR]: String(variant) });
      }

      let declined = cart.attributes && cart.attributes[ATTR] === String(variant);
      // Fällt der Warenwert unter die Schwelle, gilt die Ablehnung nicht mehr
      if (declined && !qualifies) {
        await post('cart/update.js', { attributes: { [ATTR]: '' } });
        declined = false;
      }
      const want = qualifies && !declined;

      const updates = {};
      let kept = false;
      cart.items.filter(isGift).forEach((item) => {
        if (want && !kept && item.variant_id === variant) {
          kept = true;
          if (item.quantity !== 1) updates[item.key] = 1;
        } else {
          updates[item.key] = 0;
        }
      });

      let changed = false;
      if (Object.keys(updates).length) {
        await post('cart/update.js', { updates });
        changed = true;
      }
      if (want && !kept) {
        const res = await post('cart/add.js', {
          items: [{ id: variant, quantity: 1, properties: { [PROP]: '1' } }]
        });
        if (!res.status) changed = true;
      }

      if (changed) {
        lastCart = await nativeFetch(root + 'cart.js').then((r) => r.json());
        await refresh(lastCart);
      }
    } catch (e) {
      console.error('lieberge-aktionen', e);
    } finally {
      busy = false;
      if (queued) { queued = false; schedule(); }
    }
  }

  // Cart Drawer und Warenkorbseite neu rendern, mit der Logik des Themes
  async function refresh(cart) {
    const targets = [document.querySelector('cart-drawer-items'), document.querySelector('cart-items')]
      .filter((el) => el && typeof el.getSectionsToRender === 'function');

    for (const el of targets) {
      const sections = el.getSectionsToRender().filter((s) => s.section);
      const ids = [...new Set(sections.map((s) => s.section))].join(',');
      const json = await nativeFetch(`${window.location.pathname}?sections=${ids}`).then((r) => r.json());
      sections.forEach((s) => {
        const host = document.getElementById(s.id);
        if (!host || !json[s.section]) return;
        const target = host.querySelector(s.selector) || host;
        target.innerHTML = el.getSectionInnerHTML(json[s.section], s.selector);
      });
      el.classList.toggle('is-empty', cart.item_count === 0);
      if (document.querySelector('.cart-shipping') && typeof el.cartShipping === 'function') el.cartShipping();
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);
  }

  // Belohnungs-Leiste: vom letzten Stand aus füllen, neu erreichte Etappen kurz hervorheben
  const STATE_KEY = 'lieberge-rewards';
  const readState = () => {
    try { return JSON.parse(sessionStorage.getItem(STATE_KEY)) || null; } catch (e) { return null; }
  };
  const writeState = (state) => {
    try { sessionStorage.setItem(STATE_KEY, JSON.stringify(state)); } catch (e) {}
  };

  function animateRewards() {
    const boxes = [...document.querySelectorAll('[data-rewards]:not([data-animated])')];
    if (!boxes.length) return;
    const prev = readState();
    let next = prev;
    boxes.forEach((box) => {
      box.setAttribute('data-animated', '');
      const fill = box.querySelector('.lieberge-rewards__fill');
      const pct = fill ? Number(fill.style.getPropertyValue('--p')) || 0 : 0;
      const done = [...box.querySelectorAll('.lieberge-rewards__goal.is-done')].map((g) => g.dataset.goal);
      const trio = box.querySelector('[data-goal="trio"]');
      const filled = trio ? Number(trio.dataset.filled) : 0;

      if (prev) {
        if (fill && prev.pct !== pct) {
          fill.style.transition = 'none';
          fill.style.setProperty('--p', prev.pct);
          fill.getBoundingClientRect();
          fill.style.transition = '';
          requestAnimationFrame(() => fill.style.setProperty('--p', pct));
        }
        done.filter((g) => !prev.done.includes(g)).forEach((g) => {
          const el = box.querySelector(`[data-goal="${g}"]`);
          if (el) el.classList.add('is-new');
        });
        if (trio && filled > prev.filled) {
          [...trio.querySelectorAll('.lieberge-rewards__dab')].slice(prev.filled, filled)
            .forEach((d) => d.classList.add('is-new'));
        }
      }
      next = { pct, done, filled };
    });
    writeState(next);
  }

  // Die Zeile unter dem Kasse-Button liegt auf der Warenkorbseite außerhalb der neu gerenderten Totals,
  // deshalb wird sie aus der versteckten Kopie in den Totals übernommen.
  function syncCheckoutNote() {
    const src = document.querySelector('[data-lieberge-note="src"]');
    const target = document.querySelector('[data-lieberge-note="target"]');
    if (src && target && target.innerHTML !== src.innerHTML) target.innerHTML = src.innerHTML;
  }

  let rewardsFrame = null;
  new MutationObserver(() => {
    cancelAnimationFrame(rewardsFrame);
    rewardsFrame = requestAnimationFrame(() => {
      animateRewards();
      syncCheckoutNote();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Abgelehntes Geschenk per Klick wieder hinzufügen
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-lieberge-gift-readd]');
    if (!btn) return;
    btn.disabled = true;
    await post('cart/update.js', { attributes: { [ATTR]: '' } });
    const cart = await nativeFetch(root + 'cart.js').then((r) => r.json());
    lastCart = cart;
    await refresh(cart);
    sync();
  });

  function init() {
    animateRewards();
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
